import { FC } from 'react';
import { FileByContentProps } from './types';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { modalActions } from 'reduxStore/reducers/ModalSlice';
import { FilePreview } from '../FilePreview';
import { FileCommonIcon, FileDownloadIcon, FilePreviewIcon } from 'assets/icons';
import { handleFileDownloadNew, viewFileSize } from 'utils/helpers';
import useMediaQuery from 'hooks/useMediaQuery';
import { IS_SMALL_DEVICE } from 'utils/settings';

export const FileByContent: FC<FileByContentProps> = ({
  file,
  isHideDownloadFileButton,
  isHidePreviewFileButton,
  specialFileName,
}) => {
  const dispatch = useAppDispatch();

  const isSmall = useMediaQuery(IS_SMALL_DEVICE);

  const viewFileByContent = (file: { content: string; type: string }) => {
    dispatch(
      modalActions.handleOpenModal({
        content: <FilePreview file={file} />,
        options: {
          title: 'Просмотр',
          contentClassName: 'flex w-screen sm:w-auto items-center justify-center',
        },
      })
    );
  };

  return (
    <div className="mb-1 flex items-center justify-between rounded-[0.625rem] border border-light-50 p-3 last-of-type:mb-0">
      <div className="mr-2 self-center">
        <FileCommonIcon />
      </div>
      <div className="callout-normal flex grow flex-col text-ellipsis break-all !text-text-100 sm:text-xs md:text-base">
        <span>{specialFileName ?? file.name}</span>
        <span className="footnote-normal text-text-50">
          {file.size ? viewFileSize(file.size) : ''}
        </span>
      </div>
      <div className="flex items-center gap-3">
        {!isHidePreviewFileButton && !isSmall && (
          <button
            type="button"
            className="flex h-5 w-5 items-center justify-center"
            onClick={() =>
              viewFileByContent({ content: file.content ?? '', type: file.contentType ?? '' })
            }
          >
            <FilePreviewIcon />
          </button>
        )}
        {!isHideDownloadFileButton && (
          <button
            type="button"
            className="flex h-5 w-5 cursor-pointer items-center justify-center"
            onClick={() => handleFileDownloadNew(file)}
          >
            <FileDownloadIcon className="text-primary-60" />
          </button>
        )}
      </div>
    </div>
  );
};
